<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('user.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('user.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-5">
            <ts-button color="info" outline @click="addNew()">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div class="col-md-5">
            <a-radio-group
              v-model="user_type"
              @change="onChangeUserType"
              class="ts-w-1/3"
            >
              <a-radio-button :value="1" class="ts-w-1/2 ts-text-center">
                {{ $t('user.staffUser') }}
              </a-radio-button>
              <a-radio-button :value="2" class="ts-w-1/2 ts-text-center">
                {{ $t('user.customerUser') }}
              </a-radio-button>
            </a-radio-group>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <staff v-if="user_type == 1" />
      <user-permission-report v-if="user_type == 3" />
      <customer v-if="user_type == 2" ref="customer" />
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import staff from './index-staff-v2.vue'
import customer from './index-customer-v2.vue'
import userPermissionReport from './index-user-permission-report.vue'

export default {
  name: 'userIndex',
  components: {
    staff,
    userPermissionReport,
    customer
  },
  data() {
    return {
      numeric: 1,
      visible_resetpwd: false,
      loading: false,
      errors: new Errors(),
      waiting: false,
      user_type: 1
    }
  },
  computed: {
    ...mapState('security/user', ['resources', 'pagination']),
    search: {
      get() {
        if (this.user_type == 1) {
          return this.$store.state.security.user.search
        } else {
          return this.$store.state.security.customerUser.search
        }
      },
      set(newValue) {
        if (this.user_type == 1) {
          this.$store.commit('security/user/SET_SEARCH', newValue)
          this.$store.commit('security/user/RESET_CURRENT_PAGE')
        } else {
          this.$store.commit('security/customerUser/SET_SEARCH', newValue)
          this.$store.commit('security/customerUser/RESET_CURRENT_PAGE')
        }
      }
    }
  },
  created() {
    //switch user type 
    window.addEventListener('keydown', e => {
      if (e.shiftKey && e.keyCode == 113) {
        this.user_type = 3
      }
    })
  },
  methods: {
    onChangeUserType(e) {
      // console.log(e)
    },
    addNew() {
      if (this.user_type == 1) {
        this.$router.push({ name: 'user-create' })
      } else if (this.user_type == 2) {
        this.$refs.customer.addNew()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('security/user/RESET_STATE')
    next()
  }
}
</script>
